<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useServiceStore } from '@/stores/serviceStore';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useRequestsStore } from '@/stores/storeRequests';
import BaseNumberInput from '@/components/ui/BaseNumberInput.vue';
import BaseInput from '@/components/ui/BaseInput.vue';

const storeService = useServiceStore();
const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const router = useRouter()

const nextSreen = async () => {
    await storeRequests.authorizationConfirm();
    if(!storeRequests.responseOk) return;
    if(storeRequests.userData?.is_full_profile){
        storeService.goToScreen(storeService.screens.services)
        router.push({ hash: `#${storeService.screens.services}`})
    } else {
        storeService.goToScreen(storeService.screens.authUserData)
        router.push({ hash: `#${storeService.screens.authUserData}`})
    }
  
    storeRequests.responseOk = null
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.authPhone)
    router.push({ hash: `#${storeService.screens.authPhone}`})
    storeRequests.responseError = null
    storeService.resetTimer()
}

const resetFields = () => {
    storeField.updateFields('phone', 'title', '')
    storeField.updateFields('phone', 'disabledBtn', false)
    storeField.updateFields('agreement', 'title', '')
    storeField.updateFields('agreement', 'disabledBtn', false)
}

const repeatAuth = async () => {
    await storeRequests.authorization()
    storeService.timer()
    storeField.updateFields('confirmationCode', 'title', null)
}

onMounted(() => {
    storeService.hideScreenLoader()
})
</script>
<template>
    <div class="container">
        <div class="services-container">
            <button class="services-btn-back" @click="previousSreen(), resetFields()">
                <svg width='24' height='24'><use href='#back_icon'></use></svg>
                <span>Назад</span>
            </button>
            <h2 class="service-title">авторизация</h2>

            <div class="services-form">
                <div class="form">
                    <div class="form__subtitle">
                        Мы отправили SMS с кодом активации на указанный вами номер 
                        <div class="form__subtitle-inner-btn">
                            <button type="button" @click="previousSreen">
                                {{ storeField.fields.phone.title }}
                            </button>
                            <svg @click="previousSreen" width='20' height='20'><use href='#edit'></use></svg>
                        </div>
                    </div>
                    <div :class="['form__row ', ]">
                        <div class="form__row-inner">
                            <BaseInput 
                                type="number" 
                                placeholder="Введите код"
                                state-key="confirmationCode"     
                                :required="true"
                            >
                                Код
                            </BaseInput>
                            
                            <Transition>
                                <div :class="['form__timer']">
                                    <button :disabled="storeService.timerActive" @click="repeatAuth()">
                                        Отправить код ещё раз
                                        <span v-if="storeService.timerActive">
                                            {{ storeService.remainingTime.minutes }}:{{ storeService.remainingTime.secundes }}
                                        </span> 
                                    </button>
                                </div>
                            </Transition>
                        </div>
                    </div>
                    <p class="form-text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
                    <button 
                        class="btn --full" 
                        :disabled="storeField.isSmsCodeBtn" 
                        @click="nextSreen"
                    >
                        <span v-if="!storeRequests.loaderBtn">Подтвердить</span>
                        <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                    </button>
                </div>
            </div>
            
        </div>
    </div>
</template>
<style lang='scss' scoped>
</style>